import React from 'react';

const Option = ({option, index, isActive, chooseOption, activeRadio}) => {
    const active = activeRadio === `question-${option.id}` ? "active" : "";

    return <div className="radioOption">
        { isActive ?
            <div> 
                <input 
                    type="radio" 
                    id={`question-${option.id}`} 
                    index={index}
                    value={`question-${option.id}`}
                    checked={activeRadio === `question-${option.id}`}
                    onChange={chooseOption} 
                />
                <label 
                    htmlFor={`question-${option.id}`} 
                    className={active}
                    dangerouslySetInnerHTML={{__html: option.Answer }}
                    >
                </label>
            </div>
            :
            <div> 
                <input 
                    type="radio" 
                    id={`question-${option.id}`} 
                    index={index}
                    value={`question-${option.id}`}
                    checked={activeRadio === `question-${option.id}`}
                    onChange={chooseOption} 
                    disabled
                />
                <label 
                    htmlFor={`question-${option.id}`} 
                    className={active}
                    dangerouslySetInnerHTML={{__html: option.Answer }}
                    >
                </label>
            </div>
        }
</div>
}

export default Option;